import { Routes, Route } from 'react-router-dom';
import PortalLayout from '../shared/components/PortalLayout';
import { useAuth, userIsAdmin, userIsSupervisor, userIsOficina, userVeNomina } from '../context/AuthContext';

// V3 Nómina pages
import NominaHomePage from './pages/NominaHomePage';
import ProjectSheetsPage from './pages/ProjectSheetsPage';
import TarjetaPage from './pages/TarjetaPage';
import TarjetaDetailPage from './pages/TarjetaDetailPage';
import MiSemanaPage from './pages/MiSemanaPage';   // VNA-129

// Legacy weekly timesheet pages
import MyTimesheetPage from './pages/MyTimesheetPage';
import TimesheetHistoryPage from './pages/TimesheetHistoryPage';
import TimesheetDetailPage from './pages/TimesheetDetailPage';
import TimesheetReviewPage from './pages/TimesheetReviewPage';
import TimesheetReportsPage from './pages/TimesheetReportsPage';

export default function TimesheetPortal() {
  const { user } = useAuth();
  const isAdm = userIsAdmin(user);
  const isSup = userIsSupervisor(user);
  // VNA-129 — Oficina (sin otro rol de Nómina) no tiene proyectos ni cola: su inicio es su semana.
  const soloOficina = userIsOficina(user) && !userVeNomina(user);

  return (
    <PortalLayout activeModule="horas">
      <Routes>
        {/* V3 Nómina routes (default) */}
        <Route index element={soloOficina ? <MiSemanaPage /> : <NominaHomePage />} />
        <Route path="mi-semana" element={<MiSemanaPage />} />
        <Route path="proyecto/:projectId" element={<ProjectSheetsPage />} />
        <Route path="tarjeta/:sheetId" element={<TarjetaPage />} />
        <Route path="detalle/:id" element={<TarjetaDetailPage />} />

        {/* V71: la ruta `proyecto/:projectId/gangas` (GangasPage) se retiró. Nunca tuvo
            entrada de menú en ninguna versión del repo, y su modal mandaba `persona_id`
            donde el backend guarda liderazgo por `user_id`: abrir + Editar + Guardar
            borraba TODO el liderazgo del proyecto y devolvía 200. La ganga se administra
            en Configuración → Tablas → Proyectos (`ProjectEditPage`), que es la vía que
            funciona y la que documenta el manual. */}

        {/* Legacy weekly timesheet routes */}
        <Route path="semanal" element={<MyTimesheetPage />} />
        <Route path="historial" element={<TimesheetHistoryPage />} />
        <Route path="legacy/:id" element={<TimesheetDetailPage />} />
        {isSup && <Route path="revision" element={<TimesheetReviewPage />} />}
        {isAdm && <Route path="reportes" element={<TimesheetReportsPage />} />}
      </Routes>
    </PortalLayout>
  );
}
